import React  from 'react';
import Navigation from '../components/nav';

import Profilecomponents from '../components/Profile/Profilecomponents';

const Profile = () => {
  

  return (
    <>
      <Navigation />

     <Profilecomponents />
    </>
  );
};

export default Profile;
